module.exports = __webpack_public_path__ + "static/media/jacksonville-catering-2.455ad0d0.jpg";